module.exports = __webpack_public_path__ + "static/media/direction-ltr.cbf44bfd.svg";